import axios from 'axios';
import CryptoJS from 'crypto-js';
import { prefix } from '../constants/application';

let appSettings;

const form = () => {
  async function getAppSettings() {
    const politics = document.querySelector(`.js-${prefix}-politics`);
    const ethicEmail = document.querySelector(`.js-${prefix}-ethic-email`);
    const claimsEmail = document.querySelector(`.js-${prefix}-claims-email`);
    const maxLength = document.querySelector(`.js-${prefix}-max-length`);
    const textarea = document.querySelector(`.js-${prefix}-textarea`);
    const { data } = await axios.get(`${window.location.href}appSettings.json`);
    politics.href = data.politicsURL;
    ethicEmail.href = `mailto:${data.ethicEmail}`;
    claimsEmail.href = `mailto:${data.claimsEmail}`;
    ethicEmail.innerText = data.ethicEmail;
    claimsEmail.innerText = data.claimsEmail;
    maxLength.innerText = data.maxLength;
    textarea.maxLength = data.maxLength;
    appSettings = data;
    return data;
  }

  getAppSettings();

  const ethicForm = document.querySelector(`.js-${prefix}-form`);

  const parent = (el, selector) => {
    if (el.nodeName === 'BODY') return false;
    if (el.parentNode.classList.contains(selector)) return el.parentNode;
    return parent(el.parentNode, selector);
  };

  const isValidForm = (requiredFields) => {
    let isValid = true;
    Array.prototype.forEach.call(requiredFields, (field) => {
      parent(field, 'ph-field').classList.add('is-valid');

      const hasTextareaError = !field.value || field.value.length > +appSettings.maxLength;
      const hasCheckboxError = field.type === 'checkbox' && !field.checked;
      const hasError = hasTextareaError || hasCheckboxError;

      if (hasError) parent(field, 'ph-field').classList.remove('is-valid');
      isValid = !hasError;
    });

    console.log(isValid);

    return isValid;
  };

  const showSuccessMessage = () => {
    const successHTML = `<p class="ph-success-message">${appSettings.successMessage}</p>`;
    const fieldsBlock = document.querySelector(`.js-${prefix}-fields`);
    fieldsBlock.innerHTML = successHTML;
  };

  const encryption = (number) => {
    const key = CryptoJS.enc.Utf8.parse(appSettings.key);
    const iv = CryptoJS.enc.Utf8.parse(appSettings.key);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(number), key,
      {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
    return encrypted.toString();
  };

  const sendEmail = async (bodyparts) => {
    const cta = document.querySelector(`.js-${prefix}-btn`);
    const token = encryption(Date.now());
    const emailData = {
      subject: appSettings.subject,
      to: appSettings.to,
      sendername: appSettings.sendername,
      bodyparts,
      footer: appSettings.footer,
    };

    cta.disabled = true;
    cta.innerText = appSettings.loadingText;

    try {
      const result = await axios.post(`${appSettings.baseURL}/bypass?token=${token}`, emailData);
      if (result) {
        showSuccessMessage();
      }
    } catch (error) {
      // window.location.reload();
      return error;
    }
  };

  ethicForm.addEventListener('submit', (evt) => {
    evt.preventDefault();

    const requiredFields = document.querySelectorAll('[data-rule=required]');
    if (!isValidForm(requiredFields)) return;

    let textareValue = `<p>${document.querySelector(`.js-${prefix}-textarea`).value.replace(/\n/g, ' ')}</p>`;
    const bodyparts = [];

    for (let i = 0; textareValue.length > 0; i += 1) {
      const str = textareValue.substr(0, +appSettings.bodyPartMaxLength);
      if (!str) break;
      bodyparts.push(str);
      textareValue = textareValue.substr(+appSettings.bodyPartMaxLength);
    }

    sendEmail(bodyparts);
  });
};

export default form;
